module.exports = __webpack_public_path__ + "img/img_案例06.4e39785b.png";